import { Description, FileDownload } from "@mui/icons-material";
import { Box, Card, CardContent, Chip, Grid, IconButton, styled, Switch, Tooltip } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import dayjs from "dayjs";
import FileSaver from "file-saver";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { customTheme } from "../../../../config/theme/MuiTheme";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { ContextOperation } from "../../context/OperationContext";
import { useAgGridCustomDatasource } from "../../hooks/useAgGridCustomDatasource";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import useToggle from "../../hooks/useToggle";
import { AutoCompleteOption } from "../common/AutoComplete";
import FormInput from "../common/FormInput";
import GenericFilterBox from "../common/GenericFilterBox";
import { nameof } from "../common/ObjectUtils";
import useSnackbar from "../../hooks/useSnackbar";
import AddIcon from "@mui/icons-material/Add";
import {
  getAllPart,
  getAllSeverity
} from "../damagePriceList/ManipulateValues";
import DetailsDamagePriceList from "./DetailsDamageList";
import DamagePriceService from "./service/damagePrice.action";
import { DamageTypes } from "./Types";
import DamageFormService from "../damageFormList/service/DamageFormService";
import { useNavigate } from "react-router-dom";
import * as Mui from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import { ContextDamageForm } from "../damageFormList/DamageFormContext";
import CloseDamageConfirmation from "./CloseDamageConfirmation";
import ReopenDamageConfirmation from "./ReopenDamageConfirmation";
import { useParams } from "react-router-dom";
import ChooseForm  from "./creation/dialogs/ChooseForm"
import { useHasScope } from "../../../../config/globalConfig";
import AgGridOperationTable from "../common/AgGridOperationTable";
import {useTranslation} from "react-i18next";

const StyledActionsBox = styled(Box)({
  backgroundColor: customTheme.palette.neutral.bright,
});
export const DamagePriceList = () => {
  const {i18n} = useTranslation(['operation']);
  const t = useOperationTranslation();
  const hasScope = useHasScope;

  const [ queryParams ] = useSearchParams();

  const open = useMemo(() => {
    const paramOpen = queryParams.get("open");
    if (!paramOpen) return null;

    if (paramOpen === "true") {
      return true;
    } else if (paramOpen === "false") {
      return false;
    }
  }, []);

  const damageFormContext = useContext(ContextDamageForm);
  const [listPart, setListPart] = useState<AutoCompleteOption[]>([]);
  const [listSeverity, setListSeverity] = useState<AutoCompleteOption[]>([]);
  const [damageId,setDamageId] = useState<number>();
  const [showEdit, toggleEdit] = useToggle();
  const [showClose, toggleClose] = useToggle();
  const [showReopen, toggleReopen] = useToggle();
  const [checked, setChecked] = useState(open !== null ? open : true);
  const { tenant } = useContext(ContextOperation);
  const {setLoading} = useContext(ContextOperation);
  const [isOpenChooseForm, toggleChooseForm] = useToggle();
  const [codes, setCodes] = useState<string[]>([]);

  const snackbar = useSnackbar();
  const navigate = useNavigate();

  const form = useForm<DamageTypes.FilterDamage>({
    defaultValues:{
      open: queryParams.get("open") || true,
      formCode: queryParams.get("formCode") || undefined,
    }
  });

  const showBackToForm = () => {

    if (queryParams.get("formCode") === undefined || queryParams.get("tenant") === undefined ||
        queryParams.get("formCode") === null || queryParams.get("tenant") === null ||
        queryParams.get("formCode") === '' || queryParams.get("tenant") === '') {
      return false;
    } else {
      return true;
    }
  }

  const onBackToFormDetails = () => {
    if (queryParams.get("formCode") === undefined || queryParams.get("tenant") === undefined ||
    queryParams.get("formCode") === null || queryParams.get("tenant") === null ||
    queryParams.get("formCode") === '' || queryParams.get("tenant") === '') {
      snackbar.show("warning", t("damageList.error.noformselected"));
      return;
    } else {

      var formCode = queryParams.get("formCode") || '';
      var tenant = queryParams.get("tenant") || '';

      DamageFormService.details.generalInfo.get.byCode(formCode, tenant)
      .then((response) => {
        const id = response;

        damageFormContext.setGeneralInfo(undefined);
        damageFormContext.setTask1(undefined);
        damageFormContext.setTask2(undefined);
        damageFormContext.setTask3(undefined);

        if (id === null || id === undefined) {
          snackbar.show("error", t("damageList.error.noformforcode"));
          return;
        } else {
          navigate(`/operation/damages/forms/details/${id}`);
        }
    }).catch((error: any) => {
      snackbar.show("error", "No damage form found for selected code!");
          return;
    },);
    }
  };

  const [damagePriceListDataSource,totalDamage,updateDatasourceDanger] =useAgGridCustomDatasource(
    DamagePriceService.get.getAllDamage,
    [tenant, form.getValues()],
    [tenant, form.formState.submitCount]
  );
  useEffect(() => {
    form.reset();
    form.setValue('open',true);
    getAllPart(tenant).then((response) => {
      setListPart(response);
    });
    getAllSeverity(tenant).then((response) => {
      setListSeverity(response.map((elem: any) => { return {label: t(`damageList.severityValue.${elem.value?.toLowerCase()}` as any), value: elem.value}}));
    });
  }, [tenant]);

  useEffect(() => {
    setListSeverity(listSeverity.map((elem: any) => { return {label: t(`damageList.severityValue.${elem.value?.toLowerCase()}` as any), value: elem.value}}));
  }, [i18n.language]);

  const onReset =()=>{
    form.reset();
    form.setValue('open',true);
    setChecked(true);
  }

  useEffect(() => {

    DamageFormService.list.getDamageFormCodes(tenant).then(
        response => setCodes(response),
    )

  }, [tenant]);

  
  const toggleChecked =()=>{
    form.setValue('open',!checked)
    setChecked((prev)=>!prev)
  }
  const handelDownloadExcel =()=>{
    setLoading(true);
    DamagePriceService.get.getExportExcel(tenant,form.getValues()).then((response) => {
      const filename =
        response?.headers["content-disposition"].split("filename=")[1];
      var blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(blob, filename);
      setLoading(false);
    });
    

  }
  const onSubmit =(data:any)=>{
  }

  const capitalizeFirstLetter = (data: string) => {
        const status = data.toString();
     return status == 'true' ?( <Chip color="error" label={t("damageList.fields.opens")} variant="filled" />):( <Chip color="success"  label={t("damageList.fields.closed")} variant="filled" />) ;
  };
  
  const isOpen = (data: string) => {
    const status = data.toString();
    return status == 'true' ? true : false;
  };

  const openEditModal = (id:number) => {
    setDamageId(id);
    toggleEdit();
  };

  const openCloseModal = (id:number) => {
    setDamageId(id);
    toggleClose();
 };
 
 const openReopenModal = (id:number) => {
  setDamageId(id);
  toggleReopen();
};


 const onCloseDamage = () => {
  if (!damageId) return;

  setLoading(true);
  DamagePriceService.put.closeDamage(tenant, damageId).then(
    () => {
      toggleClose();
      snackbar.show(
        "success",
        t("damageList.snackbar.close.success")
      );
      updateDatasourceDanger();
      setLoading(false);
    },
    () => {
      toggleClose();
      snackbar.show(
        "error",
        t("damageList.snackbar.close.error")
      );
      setLoading(false);
    }
  );
};

const onReopenDamage = () => {
  if (!damageId) return;

  setLoading(true);
  DamagePriceService.put.reopenDamage(tenant, damageId).then(
    () => {
      toggleReopen();
      snackbar.show(
        "success",
        t("damageList.snackbar.reopen.success")
      );
      updateDatasourceDanger();
      setLoading(false);
    },
    () => {
      toggleReopen();
      snackbar.show(
        "error",
        t("damageList.snackbar.reopen.error")
      );
      setLoading(false);
    }
  );
};

const dangerListColumns: ColDef[] = [
  {
    field: nameof<DamageTypes.FilterDamage>("formCode"),
    headerName: t("damageList.fields.formCode"),
    flex: 0.9,
    sortable: true
  },
  {
    field: nameof<DamageTypes.FilterDamage>("plate"),
    headerName: t("damageList.fields.plate"),
    flex: 0.9,
    sortable: true
  },
  {
    field: nameof<DamageTypes.FilterDamage>("label"),
    headerName: t("damageList.fields.part"),
    flex: 0.9,
    sortable: true,
    cellRenderer: (props: ICellRendererParams<DamageTypes.FilterDamage>) => {
      return (
        <Tooltip title={<>{props.data?.label}</>}>
          <span>{ t(`masterDataDamage.partName.${props.data?.partcode}` as any)  + 
          (props.data?.positoncode !== "6" ?  " " + t(`masterDataDamage.positionName.${props.data?.positoncode}` as any) : "")
           }</span>
          
        </Tooltip>);
    },
  },
  {
    field: nameof<DamageTypes.FilterDamage>("severity"),
    headerName:t("damageList.fields.severity"),
    flex: 0.9,
    sortable: true,
    cellRenderer: (params: ICellRendererParams<DamageTypes.FilterDamage>) => {
      return (
          <span>{t(`damageList.severityValue.${params.data?.severity?.toLowerCase()}` as any)}</span>
      )}
  },
  {
    field: nameof<DamageTypes.FilterDamage>("id"),
    hide: true,
  },
  {
    field: nameof<DamageTypes.FilterDamage>("damageDate"),
    headerName:t("damageList.fields.damageData"),
    flex: 0.9,
    sortable: true,
    cellRenderer:(params:any)=>{
      return(
        <>
        {dayjs(`${params.data.damageDate}`).format(
                "DD/MM/YYYY"
              )}
        </>
      )
    }
  },
  {
    field: nameof<DamageTypes.FilterDamage>("open"),
    headerName:t("damageList.fields.open"),
    flex: 0.9,
    cellRenderer: (params:any) => 
   { const status = (params.data.open).toString();
    return(
       capitalizeFirstLetter(params.data.open)
     )
  }
  },
 
  {
    maxWidth: 70,
    cellStyle: {
      padding: "0px",
      border: "none",
    },
    cellRenderer: (props: ICellRendererParams<any>) => {
      return (
        <StyledActionsBox>
            

            <Tooltip title={t("tooltipTitle.damage")}>
              <IconButton color="accent">
                <Description onClick={() => openEditModal(props.data.idDamage)}  />
                </IconButton>
                </Tooltip>
            {isOpen(props.data.open) && hasScope("SCOPE_CLOSE_DAMAGE_DAMAGE") &&
              <Mui.Tooltip title={t("tooltipTitle.closedamage")}>
                <Mui.IconButton color="accent">
                  <MuiIcons.Cancel onClick={() => openCloseModal(props.data.idDamage)} />
                </Mui.IconButton>
              </Mui.Tooltip>

            }
			{!isOpen(props.data.open) && hasScope("SCOPE_REOPEN_DAMAGE_DAMAGE") &&
              <Mui.Tooltip title={t("tooltipTitle.reopendamage")}>
                <Mui.IconButton color="accent">
                  <MuiIcons.Replay onClick={() => openReopenModal(props.data.idDamage)} />
                </Mui.IconButton>
              </Mui.Tooltip>

            }

              </StyledActionsBox>
      );
    },
  },
];
  return (
    <Box>
      <form id ="damagePrice-list"
        onSubmit={form.handleSubmit(onSubmit)}>
        <GenericFilterBox formId="damagePrice-list"
          onReset={()=>{onReset()}}>
            <FormInput
            type ="text"
            label={t("damageList.fields.formCode")}
            name ={nameof<DamageTypes.FilterDamage>("formCode")}
            formInstance={form}
            fullWidth/>

            <FormInput
            type ="text"
            label={t("damageList.fields.plate")}
            name ={nameof<DamageTypes.FilterDamage>("plate")}
            formInstance={form}
            fullWidth/>

            <FormInput
            type ="text"
            label={t("damageList.fields.vin")}
            name ={nameof<DamageTypes.FilterDamage>("vin")}
            formInstance={form}
            fullWidth/>

            <FormInput
            type="select"
            label={t("damageList.fields.part")}
            options={listPart}
            name ={nameof<DamageTypes.FilterDamage>("part")}
            value ={form.watch("part")}
            onChange ={(value)=>{
                form.setValue(
                    nameof<DamageTypes.FilterDamage>("part"),
                    value
                )
            }}
            />

      <FormInput
            type="select"
            label={t("damageList.fields.severity")}
            options={listSeverity}
            name ={nameof<DamageTypes.FilterDamage>("severity")}
            value ={form.watch("severity")}
            onChange ={(value)=>{
              console.log(value,"value")
                form.setValue(
                    nameof<DamageTypes.FilterDamage>("severity"),
                    value
                )
            }}
            />

        </GenericFilterBox>
      </form>
      <Card>
        <CardContent>
          <Box 
          sx ={{
            backgroundColor:"white",
            border:"1px solid #dbe4e9",
            borderRadius:"2px",
            padding:"9px 1px 3px 2px"
          }}>
            <Grid container
             spacing={1}
             alignItems ="center"
             alignContent="center"
             direction="row"
            >
          <Grid item xs ={6}>
            {showBackToForm() && (
                <Mui.CardHeader
                  title={
                      <Mui.Typography variant="h5">
                         {t("damageList.backtoForm")}
                      </Mui.Typography>
                  }
                  avatar={
                      <Mui.IconButton onClick={() => onBackToFormDetails()}>
                          <MuiIcons.ArrowBack />
                      </Mui.IconButton>
                  }
                />
             )}
               </Grid>
              <Grid item xs ={5.9}>
              <Box  sx ={{
                justifyContent:"flex-end",
                display:"flex"
              }}>
                
                <FormGroup>
                  <FormControlLabel
                    name ={nameof<DamageTypes.FilterDamage>("open")}
                    control ={<Switch
                      sx ={{margin:1}}
                         checked ={checked}
                         color="default"
                         onChange={toggleChecked}
                      />}
                     label = {t("damageList.fields.open")}
                     />
                </FormGroup>
                <IconButton
                 color="accent"
                 disabled ={totalDamage ? false :true}
                 onClick ={handelDownloadExcel}
                >
                 <Tooltip title ={t("tooltipTitle.download")}>
                    <FileDownload />
                 </Tooltip>
                </IconButton>
				
				{hasScope("SCOPE_CREATE_DAMAGE_DAMAGE") &&
					<IconButton color="accent" onClick={toggleChooseForm} >
                      <Mui.Tooltip title={t("tooltipTitle.add")}>
                        <AddIcon />
                      </Mui.Tooltip>
                    </IconButton>
				}

              </Box>

              </Grid>
            </Grid>
          </Box>
          <Grid>
            <AgGridOperationTable
              columnDefs={dangerListColumns}
              serverSideDatasource={damagePriceListDataSource}
              rowModelType="serverSide"
              serverSideInfiniteScroll={true}
              cacheBlockSize={10}
              rowSelection="single"
              suppressMultiSort
              totalElements ={totalDamage}
              emptyState={{
                title:t("damageList.pageTitles.noDangerTitle"),
                content:t("damageList.pageTitles.noDangerText")
              }}
            />

          </Grid>
        </CardContent>
        </Card>
        <DetailsDamagePriceList
          open={showEdit}
          onClose={toggleEdit}
          damageId ={damageId}
         />

        <CloseDamageConfirmation
          open={showClose}
          onClose={toggleClose}
          damageId ={damageId}
          onCloseDamage={onCloseDamage}
          updateDatasourceDanger={updateDatasourceDanger}
         />
		 
		  <ReopenDamageConfirmation
          open={showReopen}
          onClose={toggleReopen}
          damageId ={damageId}
          onReopenDamage={onReopenDamage}
          updateDatasourceDanger={updateDatasourceDanger}
         />

		 
		  <ChooseForm
            isOpen={isOpenChooseForm}
            onClose={toggleChooseForm}
            formCode={queryParams.get("formCode") || undefined}
            forms={codes}
        />

    </Box>
  );
};
